export { ReactComponent as HorizontalObject } from './svgs/horizontal-object.svg';
